import { ActionIcon, Container, Group, Paper, Text } from '@mantine/core';
import { IconBrandFacebook, IconBrandInstagram, IconBrandLinkedin, IconBrandTwitter, IconBrandYoutube } from '@tabler/icons-react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { availableLanguages } from '../../components/api';
import '../../css/MyFooter.css';
import useLanguageNavigator from '../../hooks/useLanguageNavigator';

interface SocialLink {
  name: string;
  url: string;
  icon: React.ReactNode;
  color: string;
}

const MyFooter = () => {
	const { language }: { language: 'en' | 'ar' } = useLanguageNavigator(availableLanguages)
	const lang = language === "en" ? "" : `/${language}`
	const data = [
		{
			title: { en: 'Smart Softek', ar: 'سمارت سوفتك' },
			links: [
				{ label: { en: 'Home Page', ar: 'الصفحة الرئيسية' }, link: `${lang}/` },
			],
		},
		{
			title: { en: 'Services', ar: 'الخدمات' },
			links: [
				{ label: { en: 'Web Apps', ar: 'تطبيقات الويب' }, link: `${lang}/webApps` },
				{ label: { en: 'Websites', ar: 'المواقع الإلكترونية' }, link: `${lang}/websites` },
				{ label: { en: 'Mobile Apps', ar: 'تطبيقات الجوال' }, link: `${lang}/mobileApps` },
				{ label: { en: 'IoT', ar: 'إنترنت الأشياء' }, link: `${lang}/iot` },
				{ label: { en: 'Electronics', ar: 'الإلكترونيات' }, link: `${lang}/electronics` },
				{ label: { en: 'Mixed Solutions', ar: 'حلول مختلطة' }, link: `${lang}/mixedSolutions` },
			],
		},
		{
			title: { en: 'About Us', ar: 'معلومات عنا' },
			links: [
				{ label: { en: 'Our Story', ar: 'قصتنا' }, link: `${lang}/ourStory` },
				{ label: { en: 'Contact Us', ar: 'اتصل بنا' }, link: `${lang}/contactUs` },
				{ label: { en: 'Careers', ar: 'الوظائف' }, link: `${lang}/careers` },
				{ label: { en: 'Sustainability', ar: 'الاستدامة' }, link: `${lang}/sustainability` },
			],
		},
	];
	const singles = {
		slogan: { en: 'Smart Softek your success partner', ar: 'سمارت سوفتك شريك نجاحك' },
		copy: { en: 'Smart Softek. All rights reserved.', ar: 'جميع الحقوق محفوظة لشركة سمارت سوفتك.' },
	}
	// onClick={(event) => event.preventDefault()}
	const groups = data.map((group) => {
		const links = group.links.map((link, index) => (
			<Text component={Link} key={index} className={"link"} to={link.link}>
				{link['label'][language]}
			</Text>
		));

		return (
			<div className={"wrapper"} key={group.title.en}>
				<Text c={'#FFF'} fz={'h3'} fw={700}>{group['title'][language]}</Text>
				{links}
			</div>
		);
  	});
	const socialLinks: SocialLink[] = [
		{
			name: 'LinkedIn',
			url: 'https://www.linkedin.com/in/mina-anton-218103156/',
			icon: <IconBrandLinkedin size={24} stroke={2} />,
			color: '#0077B5'
		},
		{
			name: 'Twitter',
			url: 'https://twitter.com/smartsoftek',
			icon: <IconBrandTwitter size={24} stroke={2} />,
			color: '#1DA1F2'
		},
		{
			name: 'YouTube',//https://www.youtube.com/channel/UCNVsrcq8FQnaf48-PwmWInA
			url: 'https://www.youtube.com/@SmartSoftek_Apps',
			icon: <IconBrandYoutube size={24} stroke={2} />,
			color: '#FF0000'
		},
		{
			name: 'Instagram',
			url: 'https://instagram.com/smartsoftek',
			icon: <IconBrandInstagram size={24} stroke={2} />,
			color: '#E4405F'
		},
		{
			name: 'Facebook',
			url: 'https://facebook.com/smartsoftek',
			icon: <IconBrandFacebook size={24} stroke={2} />,
			color: '#1877F2'
		}
	];

	return (
		<footer className={"footer"}>
			<Container className={"inner"}>
				<div className={"logo"}>
				<Link to="/" className="logo" >
					<StaticImage src='../../images/logot.png' alt="Logo" placeholder="blurred" height={70} style={{ marginTop:'1px', marginLeft:'10px' }}/>
				</Link>
				<Text size="md" c="white" className={"description"}>
					{singles['slogan'][language]}
				</Text>
				</div>
				<div className={"groups"}>{groups}</div>
			</Container>
			<Container className={"afterFooter"} >
			{/* <Grid.Col span={{ base: 2, md: 1 }} className={"afterFooter"}> */}
				<Text c="white" size="md" >
					© {new Date().getFullYear()} {singles['copy'][language]} 
				</Text>

				<Group gap={0} className={"social"} justify="flex-end" wrap="nowrap">
					<Paper c={'white'} radius={'xl'}>
						{socialLinks.map((social) => (
							<ActionIcon key={social.name} size="lg" color={social.color} variant="subtle"
								component="a" href={social.url} target="_blank" rel="noopener noreferrer"
								aria-label={`Visit Smart Softek on ${social.name}`}
							>
								{social.icon}
							</ActionIcon>
						))}
					</Paper>
				</Group>

			{/* </Grid.Col> */}
			</Container>
		</footer>
	)
}

export default MyFooter